import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMembers } from "../redux/slices/userMgtUsersSlice";
import { clearsearchFilter } from "../redux/slices/searchFilterSlice";
import DotLoader from "../components/loaders/DotLoader";
import MembersTable from "../components/MembersTable";

const Members = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  const usermgt = useSelector((state) => state?.userMgtUsers);
  console.log("usermgt", usermgt);

  const getAllUser = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchMembers());

      if (response?.payload?.name === "AxiosError") {
        setLoading(false);
        setError(
          response?.payload?.response?.data?.errors?.map((errors) => errors) ||
            response?.payload?.response?.data?.error?.description ||
            "Failed to get users, please check your request/network"
        );
      }
      setLoading(false);
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get users, please check your network"
      );
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearsearchFilter());
    getAllUser();
  }, [dispatch, getAllUser, usermgt?.memberParams]);

  const userData = useSelector(
    (state) => state?.userMgtUsers?.allMembers?.data
  );
  console.log("userData", userData);

  return (
    <Box bg={"#FFFFFF"} py={"30px"} minH={"100vh"} px={3}>
      <Flex
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={"20px"}
        mb={2}
      >
        <Text fontSize={"18px"} fontWeight={"700"} color={"#D11A2A"}>
          Members
        </Text>
        <Flex alignItems={"center"} gap={3}>
          <Flex
            as="button"
            align="center"
            gap="5px"
            cursor="pointer"
            color="#D11A2A"
            fontSize="14px"
            fontWeight="600"
            lineHeight="16px"
            // textDecoration="underline"
          >
           
          </Flex>
        </Flex>
      </Flex>
      {loading ? (
        <Flex justifyContent={"center"} alignItems={"center"}>
          <DotLoader />
        </Flex>
      ) : (
        <>
          {userData?.length > 0 ? (
            <MembersTable />
          ) : error ? (
            <Alert status="error" className="mt-3" mb={3}>
              <AlertIcon />
              <AlertTitle>{errorsArray.join(", ")}</AlertTitle>
            </Alert>
          ) : null}
        </>
      )}
    </Box>
  );
};

export default Members;
